const localizers = {
  'loading.msg': () => `Cargando...`,
  'logon.message.msg': () => `Se requiere autenticación. Introduzca un ID de usuario y una contraseña válidos.`,
  'logon.button.msg': () => `Iniciando sesión...`,
  'SASServer.logonError.msg': () => `No se puede iniciar sesión en el servidor.`,
  'SASServer.genericError.msg': () => `No se puede acceder al servidor.`,
}
export default localizers;
